// extracted by mini-css-extract-plugin
export default {"interestsSelector":"InterestsSelector_interestsSelector__z+4c1","list":"InterestsSelector_list__hHuho","description":"InterestsSelector_description__7oDVC"};